import { type CalloutSettings } from '@libraries/typescript/api_client';

export function isAutoAssignAllowed(
    calloutSettings:
        | Partial<Pick<CalloutSettings, 'allow_auto_assign'>>
        | null
        | undefined,
): boolean {
    return calloutSettings?.allow_auto_assign ?? true;
}
